import { GetAPI } from "../globalCallAPI";

export let fetchKategoriKeilmuan = async () => {
    let s = await GetAPI(`general/kategori_keilmuan/list`, {});
    return s;
};
export let fetchMediaTerbitan = async () => {
    let s = await GetAPI(`general/media_terbitan/list`, {});
    return s;
};
 